import GET_ARTICLES from "../plugins/getArticles";
import GET_CATEGORIES from "../plugins/getCategories";
const [w,d] = [window,document]
export default function SHOP(){
  w.addEventListener('DOMContentLoaded',()=>{

    // リストコンテナのクラス変更
    const list_container = d.querySelector('.element_list')
    const detail_container = d.querySelector('.element_detail')
    if(list_container){
      list_container.classList.remove('element_list')
      list_container.classList.add('p-shop__list')
    }
    if(detail_container){
      detail_container.classList.remove('element_detail')
      detail_container.classList.add('p-wholesale__detail')
    }
    $('.paginationbox').appendTo('#container')

    GET_CATEGORIES('.c-catelist',{
      itemClass: 'button button-text'
    }).done(() => {
      const id = w.location.search.match(/[?|&]article=([\d]+)?/)
      if(id && id[1]){
        $.getArticles({
          content: 'shop',post_id: id[1]
        }).done(query => {
          $('.c-catelist').currentMenu({
            mode:0,default:999,
            url: `${location.pathname}?mode=list&cat=${query[0]['category']}`
          })
        })
      }
    })

    // カテゴリブロックの移動
    {
      $('.c-catelist').parents('.block').addClass('c-catelist-block')
      $('.block_foot.c-catelist-block').appendTo('#container')
    }

  })
  
  $(()=>{

    const shop_header_init = () => {
      const params = {}
      location.search.substr(1).split('&').map(v => {
        const p = v.split('=')
        params[p[0]] = p[1]
      })
      switch(params.mode){
        case 'list':
        case 'detail':
        console.log('mode')
          $('.mainImg').remove();
          break
        default: headerSlider()
      }
    }
    const headerSlider = () =>{
      
      GET_ARTICLES('.p-shop-head').done(() => $('.p-shop-head__list').slick({
        autoplay: false,
        fade: false,
        speed: 200,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: true,
        infinite: true,
        variableWidth: true,
        swipeToSlide:true,
        slidesToShow: 4,
        centerMode: true,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            infinite: true,
            centerMode: true
          }
        }]
      }))
    }
    w.load['shop-header'].done(shop_header_init)

  })
}